<div fxFlex fxLayout="column" fxLayoutGap="25px" fxLayoutAlign="start center" class="global_login__container">

  @if (title) {
    <div class="global_login__title mb_8 mt_16">
      {{ title | translate }}
    </div>
  }
  @if (subtitle) {
    <div class="global_login__subtitle">
      {{ subtitle | translate }}
    </div>
  }

  <div [style.min-width]="minWidth">
    <st-input
      [outlined]="true"
      [control]="loginForm?.controls.username"
      #usernameInput
      (keydown.enter)="loginSubmit()"
      type="text"
      label="{{ validUserMessage() }}"
      autocapitalize="off"
      [autofill]="true"
    ></st-input>
    <st-input
      [outlined]="true"
      [control]="loginForm?.controls.password"
      (keydown.enter)="loginSubmit()"
      [isPassword]="true"
      [autofill]="false"
      label="GENERAL.PASSWORD"
    ></st-input>

    @if (alertMessage) {
      <div class="mb_8" [style.max-width]="minWidth">
        <app-alert [darkMode]="true" [message]="alertMessage" type="info"></app-alert>
      </div>
    }

      <div class="st_otp_wrapper" [style.min-width]="minWidth" style="align-items: center;" fxLayout="column">
          <div
                  class="st_modal_description st_modal_dark_font_color mb-15"
          >
              {{ 'GENERAL.MFA_AUTH_TITLE' | translate }}
          </div>

          <st-otp-input [formControl]="loginForm?.controls.auth_code" (keydown.enter)="loginSubmit()"></st-otp-input>
      </div>

    @if (shouldUseRecaptchaV2 && showRecaptcha) {
      <div fxLayout="row" fxLayoutAlign="center center" class="mb-10">
        <re-captcha
          #recaptchaV2
          [size]="!isDesktop && 'compact'"
          (resolved)="recaptchaV2Solved($event)"
          (errored)="recaptchaV2Error($event)"
        ></re-captcha>
      </div>
    }

    <!--    <div *ngIf="error && !error.message" class="custom-error">-->
    <!--      {{ getMessageError() | translate }}-->
  <!--    </div>-->
  @if (error && error.message && !alertMessage) {
    <div class="custom-error mb-10">
      <app-alert type="error" message="{{ getMessageError() | translate }}" [codeMessage]="error?.code"></app-alert>
    </div>
  }
  @if (!displayGame) {
    <div class="row-reverse" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
      <button
        fxFlex
        class="login-button"
        [disabled]="loading"
        mat-flat-button
        (click)="loginSubmit()"
        [class.spinner]="loading"
        >
        @if (!loading) {
          <span>
            {{ 'GENERAL.SIGN_IN' | translate }}
          </span>
        }
      </button>
    </div>
  }

  @if (customButtonOptions && !displayGame) {
    <button
      class="global_login__btn global_login__custom-btn mt_8"
      [disabled]="loading"
      mat-flat-button
      (click)="customButtonOptions.action()"
      [class.spinner]="loading"
      >
      <span>
        {{ customButtonOptions.title | translate }}
      </span>
    </button>
  }

</div>
</div>
